// extracted by mini-css-extract-plugin
export default {"search":"Search_search__ZHv6n"};